<template id="orgDetailsTmpl">
		<ct-main-layout-appcommerciale :backurl="backurl" :breadcrumbs="breadcrumbs">
			
			<div v-if="detailOrg != null && prjitem != null">
				
				<v-card>
					<!-- TITLE -->
					<v-card-title>
						{{$root.findTranslationInList(prjitem.project_name)}}
					</v-card-title>

					<v-card-text>
						<v-row no-gutters class="mt-3">
							<v-col cols="12" md="4">	
								<strong>{{$t('lbl.orgStatusWorkflow')}}</strong>: {{ $t('lbl.status_'+ this.prjitem.state)}}
							</v-col>
							<v-col cols="12" md="4">	
								<strong>{{$t('lbl.projectCreateDate')}}</strong>: {{ formatUnixTime(this.prjitem.create_date)}}
							</v-col>
							<v-col cols="12" md="4">	
								<strong>{{$t('lbl.projectUpdateDate')}}</strong>: {{ formatUnixTime(this.prjitem.update_date)}}
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col cols="12">
								<strong>{{$t('lbl.projectDescription')}}</strong>: {{$root.findTranslationInList(prjitem.project_description)}}
							</v-col>
						</v-row>			
					</v-card-text>


					<div v-if="prjitem.state != constantValueStatusDone">
						<v-divider></v-divider>		
						<v-card-text>
							<v-row no-gutters >
								<v-col cols="12">
									<v-btn class="button-main ma-1" v-on:click="openEditProject()"><v-icon left dark>create</v-icon>{{ $t('btn.edit')}}</v-btn>
								</v-col>
							</v-row>
						</v-card-text>	
						<v-divider></v-divider>
					</div>	
				</v-card>
				
				<v-alert :value="this.$root.changesNotSavedFlg" type="info" icon="priority_high" outlined>{{ $t('msg.dataNotSaved') }}</v-alert>

				<v-card class="mb-2">	
					<v-tabs slider-color="primary" center-active>
						<v-tab ripple v-if="prjitem.state != constantValueStatusDone">{{ $t('lbl.services')}}</v-tab>
						<v-tab ripple>{{ $t('lbl.priceQuotation')}}</v-tab>
						<v-tab ripple>{{ $t('lbl.generalDataSheet')}}</v-tab>
						<v-tab ripple>{{ $t('lbl.orgStatusWorkflow')}}</v-tab>
						<v-tab-item  v-if="prjitem.state != constantValueStatusDone">
							<v-card>
								<v-card-text>
									<ct-prj-services ref="servicesCart" :orgitem="detailOrg" :prjitem="prjitem" :servicesList="servicesList" :servicesFilterItemList="servicesFilterItemList"></ct-prj-services> 
								</v-card-text>
							</v-card>
						</v-tab-item>
						
						<v-tab-item>
							<v-card>
								<v-card-text>
									<ct-prj-price-quotation :orgitem="detailOrg" :prjitem="prjitem" :servicesList="servicesList" ></ct-prj-price-quotation>
								</v-card-text>
							</v-card>
						</v-tab-item>
						
						<v-tab-item>
							<v-card>
								<v-card-text>
									<ct-prj-data-sheet :orgitem="detailOrg" :prjitem="prjitem" :servicesList="servicesList" ></ct-prj-data-sheet>
								</v-card-text>
							</v-card>
						</v-tab-item>
						
						<v-tab-item>
							<v-card>
								<v-card-text>
									<ct-prj-workflow :orgitem="detailOrg" :prjitem="prjitem"></ct-prj-workflow>
								</v-card-text>
							</v-card>
						</v-tab-item>
									
					</v-tabs>
				</v-card>


				<!-- FORM EDIT PROJECT START -->
				<v-dialog v-model="dlgEditProjectIsOpen" v-if="prjitem != null" persistent max-width="500px" >
					<v-form ref="editProjectFrm" v-model="validEditProjectFrm" lazy-validation>
						<v-card>
							<v-card-title><span class="headline">{{ $t('lbl.editProject')}}</span></v-card-title>

							<v-card-text>
								<v-layout row wrap>
									<v-flex xs12>
										<strong>{{ $t('lbl.lang_it_IT')}}</strong>
									</v-flex>
								</v-layout>
								<v-layout row wrap>
									<v-flex xs12>
										<v-text-field v-model="prjitem.project_name.it_IT" :rules="nameRules" :label="$t('lbl.projectName')" required></v-text-field>
									</v-flex>
								</v-layout>
								<v-layout row wrap>
									<v-flex xs12>
										<v-text-field v-model="prjitem.project_description.it_IT" :rules="descriptionRules" :label="$t('lbl.projectDescription')" required></v-text-field>
									</v-flex>
								</v-layout>
								<v-layout row wrap>
									<v-flex xs12>
										<strong>{{ $t('lbl.lang_en_US')}}</strong>
									</v-flex>
								</v-layout>
								<v-layout row wrap>
									<v-flex xs12>
										<v-text-field v-model="prjitem.project_name.en_US" :rules="nameRules" :label="$t('lbl.projectName')" required></v-text-field>
									</v-flex>
								</v-layout>
								<v-layout row wrap>
									<v-flex xs12>
										<v-text-field v-model="prjitem.project_description.en_US" :rules="descriptionRules" :label="$t('lbl.projectDescription')" required></v-text-field>
									</v-flex>
								</v-layout>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn class="button-main ma-1" v-on:click="closeEditProject()" ><v-icon left dark>close</v-icon>{{ $t('btn.closeDialog')}}</v-btn>
								<v-btn class="button-main ma-1" v-on:click="saveDetailsPrj()" ><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.save')}}</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>

				</v-dialog>
				<!-- FORM EDIT PROJECT END -->
			</div>

			<v-card class="mb-2" v-else>
				<v-card-text>
					{{ $t('lbl.wait')}}
				</v-card-text>
			</v-card>		

		</ct-main-layout-appcommerciale>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctPrjServices from "@/components/appcommerciale/ctPrjServices.vue";
import ctPrjPriceQuotation from "@/components/appcommerciale/ctPrjPriceQuotation.vue";
import ctPrjDataSheet from "@/components/appcommerciale/ctPrjDataSheet.vue";
import ctPrjWorkflow from "@/components/appcommerciale/ctPrjWorkflow.vue";

export default {
	i18n,
	data: () => ({
		backurl: null,
		breadcrumbs:[],
		detailOrg: null,
		servicesList: [],
		servicesFilterItemList: [],
		prjitem: null,
		dlgEditProjectIsOpen: false,
		validEditProjectFrm: false,
		nameRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		descriptionRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		constantValueStatusDone: ''
	}),
	components: 
	{
        'ct-prj-services': ctPrjServices,
		'ct-prj-price-quotation': ctPrjPriceQuotation,
		'ct-prj-data-sheet': ctPrjDataSheet,
		'ct-prj-workflow': ctPrjWorkflow,
	},
	mounted() 
	{
		//=== NAVIGATION BAR
		this.backurl = '/appcommerciale/organization/' + this.$root.$route.params.orgId;
		this.breadcrumbs = [
			{ text: i18n.t('breadcrumb.appcommerciale'), disabled: false, href: '/tools/appcommerciale' }
		]

		//=== START LISTEN EVENTS
		events.$on(constants.EVENT_DO_LOAD_PRJ_DETAILS, () => {
			this.loadPrjDetails();
		});	
		events.$on(constants.EVENT_CHANGE_LOCALE, () => {
			this.populateTagsList();
		});	
		events.$on(constants.EVENT_DO_CHANGE_PRJ_STATUS, (newStatus) => {
			this.savePrjWorkflowStatus(newStatus);
		});	
		

		//=== APPOGGIO LE COSTANTI
		this.constantValueStatusDone = constants.PRJ_STATUS_DONE;

		//=== STARTUP
		this.loadOrgDetails();	
		this.loadPrjDetails();
	},
	destroyed() 
	{
		//=== STOP LISTEN EVENTS
		events.$off(constants.EVENT_DO_LOAD_PRJ_DETAILS);
		events.$off(constants.EVENT_CHANGE_LOCALE);
		events.$off(constants.EVENT_DO_CHANGE_PRJ_STATUS);

	},
	methods: 
	{
		loadServices() 
		{
			var endpoint2go = constants.ENDPOINT_SERVICES;
			this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadServices, 'err.loadingServices');
			
		},
		callbackLoadServices(responseData)
		{
			//var fakResponseData = '{"services":[{"service_name":{"en_US":"localizzazione persone","it_IT":"localizzazione persone"},"service_id":"srv00017","service_description":{"en_US":"rilievo presenza codificata","it_IT":"rilievo presenza codificata"},"start_date":1591787419083,"contents":{"custom_environment_creation":{"name":{"en_US":"Custom environment creation","it_IT":"Creazione ambiente personalizzato"},"description":{"en_US":"Custom environment creation description ...","it_IT":"Creazione ambiente personalizzato descrizione..."},"price":{"value":99,"currency":"EUR"}},"platform_monthly_fee":{"name":{"en_US":"Platform monthly fee","it_IT":"Canone mensile piattaforma"},"description":{"en_US":"Monthly fee for the platform","it_IT":"Canone mensile della piattaforma"},"price":{"value":43,"currency":"EUR"},"period":"monthly"},"sensor_x":{"name":{"en_US":"Sensor x","it_IT":"Sensore x"},"description":{"en_US":"Description for sensor x","it_IT":"Descrizione per sensore x"},"price":{"value":757,"currency":"EUR"},"is_multiple":true,"additional_contents":{"sensor_installation":{"name":{"en_US":"Sensor installation","it_IT":"Installazione sensore"},"description":{"en_US":"Sensor mounting on site","it_IT":"Installazione del sensore nel luogo"},"price":{"value":150,"currency":"EUR"}},"sensor_monthly_fee":{"name":{"en_US":"Sensor monthly fee","it_IT":"Canone mensile sensore"},"price":{"value":14,"currency":"EUR"},"period":"monthly"}}}},"keywords":[{"en_US":"localization","it_IT":"localizzazione"},{"en_US":"people","it_IT":"persone"}],"service_notes":{"en_US":"<strong>note</strong> in HTML","it_IT":"<strong>note</strong> in HTML"},"tags":[{"en_US":"industry","it_IT":"industria"},{"en_US":"security","it_IT":"sicurezza"},{"en_US":"iot","it_IT":"iot"}]},{"service_name":{"en_US":"attendance detection","it_IT":"rilevazione presenze"},"service_id":"srv00003","service_description":{"en_US":"Description attendance detection","it_IT":"Descrione rilevazione presenze"},"start_date":1591787419083,"contents":{"custom_environment_creation":{"name":{"en_US":"Custom environment creation","it_IT":"Creazione ambiente personalizzato"},"description":{"en_US":"Custom environment creation description ...","it_IT":"Creazione ambiente personalizzato descrizione..."},"price":{"value":129,"currency":"EUR"}},"platform_monthly_fee":{"name":{"en_US":"Platform monthly fee","it_IT":"Canone mensile piattaforma"},"description":{"en_US":"Monthly fee for the platform","it_IT":"Canone mensile della piattaforma"},"price":{"value":51,"currency":"EUR"},"period":"monthly"},"sensor_y":{"name":{"en_US":"Sensor y","it_IT":"Sensore y"},"description":{"en_US":"Description for sensor y","it_IT":"Descrizione per sensore y"},"price":{"value":838,"currency":"EUR"},"is_multiple":true,"additional_contents":{"sensor_installation":{"name":{"en_US":"Sensor installation","it_IT":"Installazione sensore"},"description":{"en_US":"Sensor mounting on site","it_IT":"Installazione del sensore nel luogo"},"price":{"value":186,"currency":"EUR"}},"sensor_monthly_fee":{"name":{"en_US":"Sensor monthly fee","it_IT":"Canone mensile sensore"},"price":{"value":12,"currency":"EUR"},"period":"monthly"}}}},"keywords":[{"en_US":"localization","it_IT":"localizzazione"},{"en_US":"people","it_IT":"persone"}],"service_notes":{"en_US":"<strong>note</strong> in HTML","it_IT":"<strong>note</strong> in HTML"},"tags":[{"en_US":"industry","it_IT":"industria"},{"en_US":"security","it_IT":"sicurezza"},{"en_US":"iot","it_IT":"iot"},{"en_US":"building","it_IT":"building"}]}]}';
			//responseData = JSON.parse(fakResponseData);
			if(!this.isEmptyObj(responseData))
			{
				this.servicesList = responseData.services;
				//this.servicesListId = this.getServiceIdList(this.servicesList);
				this.populateTagsList();

				this.launchLoadedPrjEvents();
				
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.loadingServices'));
			}
		},
		loadOrgDetails() 
		{
			var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/'+ this.$route.params.orgId;
			this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadOrgDetails, 'err.loadingOrg');
		},
		callbackLoadOrgDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData) && !this.isEmptyString(responseData.organization_id))
			{
				//=== SETTO DETTAGLIO ORGANIZZAZIONE
				this.detailOrg = responseData;

				this.breadcrumbs.push({text: this.detailOrg.organization_name, disabled: false, href: '/tools/appcommerciale/organization/'+ this.$route.params.orgId });

				this.newNameOrganization = this.detailOrg.organization_name;
				
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.loadingOrg'));
			}
		},
		loadPrjDetails() 
		{
			var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + this.$route.params.orgId + '/projects/' + this.$route.params.prjId;
			this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadPrjDetails, 'err.loadingPrj');
		},
		callbackLoadPrjDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.prjitem = responseData;

				this.breadcrumbs.push({text: this.$root.findTranslationInList(this.prjitem.project_name), disabled: false});

				if(this.prjitem.state == constants.PRJ_STATUS_DONE)
				{
					//=== LANCIO EVENTI
					this.launchLoadedPrjEvents();
				} 
				else 
				{
					if(!this.isEmptyObj(this.servicesList) && Array.isArray(this.servicesList) && this.servicesList.length > 0)
					{
						//=== LANCIO EVENTI
						this.launchLoadedPrjEvents();
					}
					else 
					{
						//=== LANCIO CARICAMENTO SERVIZI
						//=== LA PRIMA VOLTA CHE ENTRO
						this.loadServices();
					}
				}	
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.loadingPrj'));
			}
		},
		launchLoadedPrjEvents()
		{
			//=== EVENTO INIT CARRELLO
			events.$emit(constants.EVENT_DO_INIT_CART, this.prjitem.services, this.servicesList);

			//=== EVENTO INIT PRICE QUOTATION
			events.$emit(constants.EVENT_DO_INIT_PRICE_QUOTATION, this.prjitem, this.servicesList);
			
			//=== EVENTO INIT DATASHEET
			events.$emit(constants.EVENT_DO_INIT_DATASHEET, this.prjitem, this.servicesList);

			//=== EVENTO INIT WORKFLOW
			events.$emit(constants.EVENT_DO_INIT_WORKFLOW, this.prjitem);
		},
		populateTagsList() 
		{
			try{
				// RESET
				this.servicesFilterItemList = ['all'];
				for (var i = 0; i < this.servicesList.length; i++) 
				{ 
					try{ 
						var serviceObj = this.servicesList[i];
						for (var j = 0; j < serviceObj.tags.length; j++) 
						{ 
							var serviceTagObj = serviceObj.tags[j];
							var tagInLang = this.findTranslationInList(serviceTagObj);
							if(this.servicesFilterItemList.includes(tagInLang) == false )
							{
								this.servicesFilterItemList.push(tagInLang);
							}
						}
					} catch(err) {
						console.log(err);
					}
				}				
			} catch(err) {
				console.log(err);
			}
		}, 
		openEditProject()
		{
			this.dlgEditProjectIsOpen = true;

		},
		closeEditProject()
		{
			this.dlgEditProjectIsOpen = false;
		},
		saveDetailsPrj() 
		{
			var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + this.detailOrg.organization_id + '/projects/' + this.prjitem.project_id;
			var obj2send = this.prjitem;
			
			this.$root.genericPutAuthenticatedCallEngine(endpoint2go, obj2send, this.callbackSaveDetailsPrj, 'err.savingPrj');
		},
		callbackSaveDetailsPrj(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.$root.setDialogMsg(i18n.t('msg.saveok'));

				//=== LANCIO EVENTO RICARICA PROGETTO
				events.$emit(constants.EVENT_DO_LOAD_PRJ_DETAILS);
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.savingPrj'));
			}
		}, 
		getMyCurrentCart()
		{
			if (this.$refs.servicesCart)
			{
				return this.$refs.servicesCart.getMyCurrentCart();

			} else 
			{ 
				return null;
			}
		},
		savePrjWorkflowStatus(newStatus)
		{
			
			var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + this.detailOrg.organization_id + '/projects/' + this.prjitem.project_id;
			var youCanSave = true;

			var obj2send = this.prjitem;
			obj2send.state = newStatus;

			var services2send = [];
			if(obj2send.state == constants.PRJ_STATUS_DONE)
			{
				
				this.$root.setDialogMsg(i18n.t('msg.freezeProject'));

				//=== RECUPERO IL CARRELLO CORRENTE
				// CICLO SUL CARRELLO CRRENTE
				// E COSTRUISCO LA LISTA INSERENDO ANCHE OGGETTO SERVICE COSI CONGELO I PREZZI
				let servicesToIterate = this.getMyCurrentCart();
				if(!this.isEmptyObj(servicesToIterate))
				{
					for (let i = 0; i < servicesToIterate.length; i++) 
					{
						let serviceObjTmp = servicesToIterate[i];
						let obj2add = {};
						obj2add.service_id = serviceObjTmp.service_id;
						obj2add.service = serviceObjTmp.service;
						obj2add.notes = serviceObjTmp.notes;
						obj2add.contents_data = serviceObjTmp.contents_data;
						
						services2send.push(obj2add);
					}
				} 
				else
				{
					youCanSave = false;
					this.$root.setDialogMsg(i18n.t('err.prjChangeStatusCartNotValid'));
				}
			} 
			else 
			{
				// CICLO SUI SERVICES DEL PROGETTO
				// RISCOSTRUISCO LA LISTA COSI SE NEL SALVATAGGI PRECEDENTE ERO NELLO STATO CONCLUSO
				// ED AVEVO L OGGETTO SERVICE ADESSO LO RIMUOVO
				let servicesToIterate = this.prjitem.services;
				if(!this.isEmptyObj(servicesToIterate))
				{
					for (let i = 0; i < servicesToIterate.length; i++) 
					{
						let serviceObjTmp = servicesToIterate[i];
						let obj2add = {};
						obj2add.service_id = serviceObjTmp.service_id;
						obj2add.notes = serviceObjTmp.notes;
						obj2add.contents_data = serviceObjTmp.contents_data;

						services2send.push(obj2add);
					}
				} 
				else
				{
					youCanSave = false;
					this.$root.setDialogMsg(i18n.t('err.prjChangeStatusServicesNotValid'));
				}
			}

			//=== SETTO LA LISTA DEI SERVICES
			obj2send.services = services2send;
			
			//=== SAVING
			if(youCanSave)
			{
				this.$root.genericPutAuthenticatedCallEngine(endpoint2go, obj2send, this.callbackPrjWorkflowStatus, 'err.savingPrj');
			}
			
		},
		callbackPrjWorkflowStatus(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				//=== LANCIO EVENTO RICARICA PROGETTO
				events.$emit(constants.EVENT_DO_LOAD_PRJ_DETAILS);
			} 
			else 
			{
				this.$toot.setDialogMsg(i18n.t('err.savingPrj'));
			}
		},
	}
}
</script>